export default __webpack_public_path__ + "static/media/birbconcern.3089aad3.png";